import type { VocabDictionary } from "../../API/Context/LanguageContext";

export const VocabSkills = {
  skills_title: ["Especialidad y Habilidades", "Specialty and Skills"],
  search_skill: ["Buscar habilidad", "Search skill"],
  search_skill_placeholder: ["Buscar...", "Search..."],
  specialty: ["Especialidad", "Specialty"],
  subspecialty: ["Subespecialidad", "Subspecialty"],
  current_skills: ["Habilidades actuales", "Current skills"],
  no_selection: ["No hay habilidades seleccionadas.", "No skills selected."]
} as const satisfies VocabDictionary;

export type VocabSkillsKey = keyof typeof VocabSkills;
export default VocabSkills;